import { Component,ViewChild, inject,ElementRef } from '@angular/core';
import { ImageCroppedEvent, LoadedImage ,Dimensions,ImageTransform} from "ngx-image-cropper";
import { DomSanitizer } from "@angular/platform-browser";
import { GlobalService } from 'src/app/Services/global.service';
import {
  HttpClient,
  HttpEventType,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

declare var $:any;

@Component({
  selector: 'app-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.scss']
})
export class CreatePostComponent {

  progress: number = 0;
  message: string = '';

  public selectedFile: any = "";
  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedImage1: any = '';
  canvasRotation = 0;
  rotation?: number;
  translateH = 0;
  translateV = 0;
  scale = 1;
  aspectRatio = 4 / 3;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {
    translateUnit: 'px'
  };
  imageURL?: string;
  loading = false;
  allowMoveImage = false;
  hidden = false;

  constructor(
    private sanitizer: DomSanitizer ,public service: GlobalService,private http: HttpClient
  ) {
  }

  fileChangeEvent(event: any): void {
    this.loading = true;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl || event.base64 || '');
    console.log(event);
  }

  imageCropped1(event: any) {
    var reader = new FileReader();
    reader.readAsDataURL(event.blob);
    const self = this;
    reader.onloadend = function () {
      var base64data = reader.result;
      self.croppedImage1 = base64data;
    }
  }
  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    console.error('Load image failed');
  }

  rotateLeft() {
    this.loading = true;
    setTimeout(() => { // Use timeout because rotating image is a heavy operation and will block the ui thread
      this.canvasRotation--;
      this.flipAfterRotate();
    });
  }

  rotateRight() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation++;
      this.flipAfterRotate();
    });
  }

  moveLeft() {
    this.transform = {
      ...this.transform,
      translateH: ++this.translateH
    };
  }

  moveRight() {
    this.transform = {
      ...this.transform,
      translateH: --this.translateH
    };
  }

  moveTop() {
    this.transform = {
      ...this.transform,
      translateV: ++this.translateV
    };
  }

  moveBottom() {
    this.transform = {
      ...this.transform,
      translateV: --this.translateV
    };
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
    this.translateH = 0;
    this.translateV = 0;
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {
      translateUnit: 'px'
    };
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  toggleContainWithinAspectRatio() {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  updateRotation() {
    this.transform = {
      ...this.transform,
      rotate: this.rotation
    };
  }

  toggleAspectRatio() {
    this.aspectRatio = this.aspectRatio === 4 / 3 ? 16 / 5 : 4 / 3;
  }

  uploadImage(){
    this.loading=true;
    var url="/update-profile-image";
    let formdata= new FormData();
    if (this.croppedImage == '') {
      this.service.dangerAlert('Profile Image is Required');
      this.loading = false;
      return
    } else {
      // if (this.selectedFile != '') {
        const fileObject = this.service.dataURLtoFile(this.croppedImage1, 'album.png');
        formdata.append('profile', fileObject);
      // }
    }
    this.service.PostApiFormData(formdata,url).subscribe(((response:any)=>{
      if(response.success ==1){ 
        this.selectedFile='';
        // this.
        this.loading=false;               
      } else {
        this.loading=false;
      }
    }), (error:any) => {
    });
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.progress = 0; // Reset progress
      this.message = ''; // Reset message
    }
  }

  uploadFile(): void {
    if (this.selectedFile) {
      const formData:any = new FormData();
      formData.append('video_file', this.selectedFile, this.selectedFile.name);
      formData.append('post_id', localStorage.getItem('grw_content_id'));
      formData.append('duration', 5);
      const uploadReq = new HttpRequest(
        'POST',
        environment.apiEndPoint + '/upload-post-video',
        formData,
        {
          headers: this.service.getHeaderLogin().headers,
          reportProgress: true,
        }
      );

      this.http.request(uploadReq).subscribe(
        (event: any) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.progress = Math.round((100 * event.loaded) / event.total);
              }
              break;
            case HttpEventType.Response:
              this.message = event.body?.success == 1
                ? 'File uploaded successfully!'
                : event.body?.message || 'Error uploading file!';
              break;
            default:
              break;
          }
        },
        (error) => {
          this.message = 'Error uploading file!';
          console.error(error);
        }
      );
    }
  }
}
